import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  MeteringConceptInfo,
  SiteOverviewSite,
  SiteStatusSite
} from "../../site-status-types";

interface MeteringConceptInfoColumnProps {
  onClickMeteringConceptInfoCell: (mbkInfo: MeteringConceptInfo) => void;
}

function getMeteringConceptInfoColumn({
  onClickMeteringConceptInfoCell
}: MeteringConceptInfoColumnProps): MRT_ColumnDef<
  SiteOverviewSite | SiteStatusSite
> {
  return {
    header: "MBK Erstellung",
    accessorKey: "meteringConceptInfo",
    Cell: ({ cell }) => (
      <MeteringConceptInfoCell
        mbkInfo={cell.getValue<MeteringConceptInfo>()}
        onClick={onClickMeteringConceptInfoCell}
      />
    ),
    enableSorting: false,
    filterFn: (row, _columnId, filterValue) => {
      return row
        .getValue<MeteringConceptInfo>("meteringConceptInfo")
        .errorMessages.join(" ")
        .includes(filterValue);
    },
    enableGlobalFilter: false
  };
}

interface MeteringConceptInfoCellProps {
  mbkInfo: MeteringConceptInfo;
  onClick: (mbkInfo: MeteringConceptInfo) => void;
}

function MeteringConceptInfoCell({
  mbkInfo,
  onClick
}: MeteringConceptInfoCellProps) {
  const executionState = mbkInfo.executionState;
  const errorMessages = mbkInfo.errorMessages;
  const clickable = errorMessages?.length > 0;
  const handleClick = () => {
    if (clickable) {
      onClick(mbkInfo);
    }
  };

  if (executionState) {
    return (
      <div
        className={clickable ? "linked-label-cell-span" : ""}
        onClick={handleClick}
      >
        {executionState}
      </div>
    );
  } else {
    return <span>-</span>;
  }
}

export { getMeteringConceptInfoColumn };
